export default "__VITE_ASSET__C4PNbC47__"